import { AttendingEventType } from "store/attendingEvents/attendingEvents.types";
import styled from "styled-components";

export const StatusBadge = styled.div<{ type: AttendingEventType }>`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  margin-top: 0.375rem;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.05);
  width: fit-content;
  
  &:hover {
    transform: translateY(-0.0625rem);
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
  }
  
  ${({ type }) => {
    switch (type) {
      case AttendingEventType.HOST:
        return 'background-color: #FDE68A; color: #B45309; border: 0.0625rem solid rgba(180, 83, 9, 0.1);';
      case AttendingEventType.CONFIRMED:
        return 'background-color: #A7F3D0; color: #047857; border: 0.0625rem solid rgba(4, 120, 87, 0.1);';
      case AttendingEventType.TENTATIVE:
        return 'background-color: #FCA5A5; color: #B91C1C; border: 0.0625rem solid rgba(185, 28, 28, 0.1);';
      case AttendingEventType.REFUSED:
        return 'background-color: #FEE2E2; color: #DC2626; border: 0.0625rem solid rgba(220, 38, 38, 0.1);';
      default:
        return 'background-color: #F3F4F6; color: #1F2937; border: 0.0625rem solid rgba(31, 41, 55, 0.1);';
    }
  }}
`; 